import React, {useState, useEffect, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Spinner, 
  Input, 
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Slider,
  Checkbox,
  IconButton,
  Typography,
  Radio,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Tooltip
} from '@material-tailwind/react'
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { getOp20Trade, saveOp20TradeDataForDomain, getTradeActivityForDomain, getOp20TradeCheck, getOp20TradeListForDomain, getOp20TradeListByAddressForDomain } from '../../../util/op20-api';
import { debounce } from 'lodash';
import { formatFloat, formatNumberWithCommas, convertTimestampToDate } from '../../../util/format-data';
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, FunnelIcon, ArrowLongDownIcon, ArrowLongUpIcon, InformationCircleIcon, CircleStackIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import { useSelector } from 'react-redux';
import Op20NameCard from '../../TokenSaleCard/Op20NameCard';
import { convertTimestamp, formatAddress } from '../../../util/format-data';

import Op20NameCardForBuy from '../../Cards/Op20NameCard';

const Op20Domain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const wallet = useSelector(state => state.wallet);
  const { bitcoin: price } = useSelector(state => state.price);
  const [ticker, setTicker] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [datas, setDatas] = useState([]);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [order, setOrder] = useState(1);
  const [activityFilter, setActivityFilter] = useState("buy");
  const [activityTotal, setActivityTotal] = useState(0);
  
  useEffect(() => {
    fetchData(ticker, page);
  }, [active, page, order, refresh, activityFilter, wallet.nostrOrdinalsAddress]);

  const getSortAndDirect = () => {
    switch (order) {
      case 1:
        return { sort: "id", direct: "desc" };
      case 2:
        return { sort: "id", direct: "asc" };
      case 3:
        return { sort: "unitPrice", direct: "desc" };
      case 4:
        return { sort: "unitPrice", direct: "asc" };
    }
  }
  
  const fetchData = async (ticker, page) => {
    const { sort, direct } = getSortAndDirect();
    setLoading(true);
    if (active == 0) {
      let results = await getOp20TradeListForDomain(page, limit, 1, sort, direct, ticker);
      setDatas(results.data);
      setTotal(Math.ceil(results.total / limit));
    }
    else if (active == 1) {
      let results = await getTradeActivityForDomain(1, activityFilter, page, limit);
      setDatas(results.data);
      setTotal(Math.ceil(results.total / limit));
      setActivityTotal(results.total);
    }
    else if (active == 2) {
      let results = await getOp20TradeListByAddressForDomain(1, wallet.nostrOrdinalsAddress, ticker, page, limit);
      setDatas(results.data);
      setTotal(Math.ceil(results.total / limit));
    }
    setLoading(false);
  }

  const handleFetchData = async () => {
    const { sort, direct } = getSortAndDirect();
    setLoading(true);
    if (active == 0) {
      let results = await getOp20TradeListForDomain(page, limit, 1, sort, direct, ticker);
      setDatas(results.data);
      setTotal(Math.ceil(results.total / limit));
    }
    else if (active == 1) {

    }
    else if (active == 2) {
      let results = await getOp20TradeListByAddressForDomain(1, wallet.nostrOrdinalsAddress, ticker, page, limit);
      setDatas(results.data);
      setTotal(Math.ceil(results.total / limit));
    }
    setLoading(false);
  }

  const debouncedSearch = useCallback(debounce(async (value) => {
    await fetchData(value, 1);
  }, 500), []); 

  const handleSearch = (e) => {
    setTicker(e.target.value);
    setPage(1);
    debouncedSearch(e.target.value);
  }

  const handleOrder = (value) => {
    setOrder(value);
  }

  const handleRefresh = useCallback(() => {
    setRefresh(refresh => 1 - refresh);
  }, []);

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const doublePrev = () => {
    setPage(1);
  }

  const doubleNext = () => {
    setPage(total);
  }


  return (
    <div className="text-white mt-3 w-full px-1 flex flex-col items-center mb-10 min-h-[600px] gap-3">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      
      <div className="w-full flex flex-col gap-2">
        <div className="font-bold text-primary text-[20px]">
          <Radio 
            name="type" 
            color="pink" 
            checked={active == 0}
            onChange={() => setActive(0)}
            className={`${active == 0 ? 'border-primary' : 'border-white'}`}
            label={
              <Typography
              className={`flex font-medium  ${active == 0 ? 'text-primary' : 'text-white'}`}
              >
                {t('Items')}
              </Typography>
            } 
          />
          <Radio 
            name="type" 
            color="pink" 
            checked={active == 1}
            onChange={() => setActive(1)}
            className={`${active == 1 ? 'border-primary' : 'border-white'}`}
            label={
              <Typography
              className={`flex font-medium  ${active == 1 ? 'text-primary' : 'text-white'}`}
              >
                {t('Activity')}
              </Typography>
            } 
            defaultChecked 
          />
          <Radio 
            name="type" 
            color="pink" 
            checked={active == 2}
            onChange={() => setActive(2)}
            className={`${active == 2 ? 'border-primary' : 'border-white'}`}
            label={
              <Typography
                className={`flex font-medium  ${active == 2 ? 'text-primary' : 'text-white'}`}
              >
                {t('My Items')}
              </Typography>
            } 
          />
        </div>
        {
          active == 1 ?
          <></>
          :
          <div className="flex flex-row justify-end items-center gap-2 w-full">
            <div><Input type="text" color="white" label = {t('Search By Domain Name')} className="w-[250px]" value = {ticker} onChange = {(e) => {handleSearch(e)}}/></div>
            <Tooltip content="Refresh">
              <div className="border-borderColor border-solid border-[1px] rounded-md p-[6px] cursor-pointer" onClick={() => handleFetchData()}><ArrowPathIcon strokeWidth={2} className="h-6 w-6" /></div>
            </Tooltip>
            {
              active == 0 ?
              <Tooltip content="Filter">
                <Menu placement="bottom-end">
                  <MenuHandler>
                    <div className="border-borderColor border-solid border-[1px] rounded-md p-[6px] cursor-pointer"><FunnelIcon strokeWidth={2} className="h-6 w-6" /></div>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white">
                    <MenuItem onClick={() => handleOrder(1)}>{t('Newest')}</MenuItem>
                    <MenuItem onClick={() => handleOrder(2)}>{t('Oldest')}</MenuItem>
                    <MenuItem onClick={() => handleOrder(3)}>{t('Highest Price')}</MenuItem>
                    <MenuItem onClick={() => handleOrder(4)}>{t('Lowest Price')}</MenuItem>
                  </MenuList>
                </Menu>
              </Tooltip>
              :
              <></>
            }
            {
              active == 2 ?
              <div className="bg-primary text-white px-4 py-2 rounded-md cursor-pointer font-bold sm:flex hidden" onClick={() => navigate(`/inscribe/op_return`)}>{t('Inscribe Transfer')}</div>
              :
              <></>
            }
          </div>
        }
        {
          active == 2 && !loading ?
          <div className="grid 2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 w-full mt-5">
            {
              datas.length > 0 ?
              datas.map((data) => 
                <Op20NameCard key={data.domain} data = {data} keyAddress = {wallet.nostrOrdinalsAddress} isSale = {true} handleRefresh = { handleRefresh } price = {price}/>
              ) : <div>{t('No Domain Names')}</div>
            }
          </div>
          :
          <></>
        }
        {
          active == 0 && !loading ?
          <div className="grid 2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 w-full mt-5">
            {
              datas.length > 0 ?
              datas.map((data) => 
                <Op20NameCardForBuy key={data.ticker} data = {data} keyAddress = {wallet.nostrOrdinalsAddress} handleRefresh = { handleRefresh } price = {price}/>
              ) : <div>{t('No Domain Names')}</div>
            }
          </div>
          :
          <></>
        }
        {
          active == 1 && !loading ?
          <div className="flex flex-col gap-2 w-full bg-background2 rounded-md p-4 min-h-[600px]">
            <div className="flex flex-row justify-between">
              <span className="text-white text-xl font-bold">{t('Activity')} ({activityTotal})</span>
              <div>
              <Tooltip content={t('Filter')}>
                <Menu placement="bottom-end">
                  <MenuHandler>
                    <div className="border-borderColor border-solid border-[1px] rounded-md p-[6px] cursor-pointer"><FunnelIcon strokeWidth={2} className="h-6 w-6" /></div>
                  </MenuHandler>
                  <MenuList className="bg-black border-black text-white">
                    <MenuItem onClick={() => setActivityFilter('buy')}>{t('Sale')}</MenuItem>
                    <MenuItem onClick={() => setActivityFilter('list')}>{t('List')}</MenuItem>
                    <MenuItem onClick={() => setActivityFilter('delist')}>{t('Cancel')}</MenuItem>
                  </MenuList>
                </Menu>
              </Tooltip>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-row text-white font-bold border-b-[1px] border-background1 px-2">
                <div className="sm:w-[15%] w-[40%] ">{t('Time')}</div>
                <div className="w-[15%] sm:flex hidden">{t('Type')}</div>
                <div className="sm:w-[16%] w-[30%]">{t('Domain')}</div>
                <div className="sm:w-[20%] w-[30%]">{t('Price')}</div>
                <div className="w-[17%] sm:flex hidden">{t('Sender')}</div>
                <div className="w-[17%] sm:flex hidden">{t('Receiver')}</div>
              </div>
              {
                datas.map((item, index) => (
                  <div key={uuidv4()} className="flex flex-row text-white py-2 border-b-[1px] border-background1 items-center hover:bg-background px-2">
                    <div className="sm:w-[15%] w-[40%] flex flex-row items-center gap-1">
                      <span>{item.updatedAt ? convertTimestamp(item.updatedAt) : convertTimestamp(item.createdAt)}</span>
                      {
                        item.txId ?
                        <svg onClick = {() => window.open(`https://mempool.space/tx/${item.txId}`, "_blank")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" className="tw-opacity-60 cursor-pointer" color="rgb(var(--textColor-primary))" width="18" height="18" size="18"><path d="M13.5 6.5L13.4994 2.50062L9.5 2.5M8.5 7.5L13.5 2.5M11.5 8.5V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7.5" stroke="currentColor" strokeLinecap="round" stroke-linejoin="round"></path></svg>
                        :
                        <></>
                      }
                    </div>
                    <div className="w-[15%] sm:flex hidden">{activityFilter}</div>
                    <div className="sm:w-[16%] w-[30%] flex flex-row items-center gap-1">
                      <span>{item.ticker}</span>
                    </div>
                    <div className="sm:w-[20%] w-[30%] flex flex-col">
                      <span>{formatFloat(item.totalPrice / Math.pow(10, 8), 5)} BTC</span>
                      <span className="text-gray-400 text-sm">${formatFloat(price * item.totalPrice / Math.pow(10, 8), 2)}</span>
                    </div>
                    <div className="w-[17%] sm:flex hidden">{formatAddress(item.ownerAddress)}</div>
                    <div className="w-[17%] sm:flex hidden">{formatAddress(item.receiverAddress)}</div>
                  </div>
                ))
              }
            </div>
          </div>
          :
          <></>
        }
        {
          total > 1 ? 
          <div className="flex flex-row items-center justify-center gap-8 mt-5">
            <div className="flex flex-row items-center gap-2">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={doublePrev}
                disabled={page === 1}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={prev}
                disabled={page === 1}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
            <Typography color="white" className="font-normal">
              {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
              <strong className="text-primary">{total}</strong>
            </Typography>
            <div className="flex flex-row items-center gap-2">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={next}
                disabled={page === total}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={doubleNext}
                disabled={page === total}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
          </div>
          :
          <></>
        }
      </div>
    </div>
  );
};

export default Op20Domain;